import { getAPI, postAPI } from '../utils/api';
import endpoints from '../utils/endpoints';

const resolveParams = (paramsOrCallback, callBackOrError, maybeError) => {
  const hasParams =
    typeof paramsOrCallback === 'object' && paramsOrCallback !== null;
  return {
    params: hasParams ? paramsOrCallback : {},
    callBack: hasParams ? callBackOrError : paramsOrCallback,
    errorCallback: hasParams ? maybeError : callBackOrError,
  };
};

export const getFailedTransactions = (
  paramsOrCallback,
  callBackOrError,
  maybeError
) => {
  const { params, callBack, errorCallback } = resolveParams(
    paramsOrCallback,
    callBackOrError,
    maybeError
  );

  return (dispatch) => {
    getAPI(
      endpoints.GET_FAILED_TRANSACTIONS,
      params,
      (data) => callBack(data),
      (err) => errorCallback(err),
      localStorage.getItem('token')
    );
  };
};

export const getFailedTransactionsAnalytics = (
  paramsOrCallback,
  callBackOrError,
  maybeError
) => {
  const { params, callBack, errorCallback } = resolveParams(
    paramsOrCallback,
    callBackOrError,
    maybeError
  );

  return (dispatch) => {
    getAPI(
      endpoints.GET_FAILED_TRANSACTIONS_ANALYTICS,
      params,
      (data) => callBack(data),
      (err) => errorCallback(err),
      localStorage.getItem('token')
    );
  };
};

export const refundFailedTransaction = (
  transactionId,
  body,
  callBack,
  errorCallback
) => {
  return (dispatch) => {
    postAPI(
      endpoints.REFUND_FAILED_TRANSACTION.replace(
        ':transactionId',
        transactionId
      ),
      body,
      (data) => callBack(data),
      (err) => errorCallback(err),
      localStorage.getItem('token')
    );
  };
};

export const closeFailedTransactionCase = (
  transactionId,
  body,
  callBack,
  errorCallback
) => {
  return (dispatch) => {
    postAPI(
      endpoints.CLOSE_FAILED_TRANSACTION.replace(
        ':transactionId',
        transactionId
      ),
      body,
      (data) => callBack(data),
      (err) => errorCallback(err),
      localStorage.getItem('token')
    );
  };
};
